import { Component, JSX } from 'solid-js';

type PillTab = {
  id: string;
  label: string;
  // Accept any SolidJS component that renders an icon (e.g. icons from
  // @atgfr8/icons or any local component that accepts a `class` prop).
  icon: Component<{ class?: string }>;
};

type StickyPillTabsProps = {
  tabs: readonly PillTab[];
  value: () => string;
  onChange: (id: string) => void;
  actionButton?: JSX.Element;
  disabledTabs?: readonly string[];
  class?: string;
};

export function StickyPillTabs(props: StickyPillTabsProps) {
  const handleKeyDown = (event: KeyboardEvent, tabId: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      props.onChange(tabId);
    }
  };

  return (
    <div
      class={`sticky z-10 bg-white p-2 rounded-md shadow-md ${props.class || ''}`}
    >
      <div
        class={`flex items-center justify-between gap-2 ${props.actionButton ? 'mb-2' : ''}`}
      >
        {props.tabs.map((tab) => {
          const Icon = tab.icon;
          const active = props.value() === tab.id;
          const disabled = props.disabledTabs?.includes(tab.id) ?? false;

          return (
            <div
              role="button"
              aria-pressed={active}
              aria-disabled={disabled}
              tabIndex={disabled ? -1 : 0}
              class={`flex items-center justify-center gap-2 px-4 py-2 rounded-full transition-all
                ${disabled ? 'opacity-40 cursor-not-allowed text-gray-400' : 'cursor-pointer'}
                ${active && !disabled ? 'bg-[#123B50] text-white' : !disabled ? 'text-gray-500' : ''}`}
              onClick={() => !disabled && props.onChange(tab.id)}
              onKeyDown={(e) => !disabled && handleKeyDown(e, tab.id)}
            >
              <Icon class="text-2xl!" />
              {active && !disabled && <span>{tab.label}</span>}
            </div>
          );
        })}
      </div>

      {props.actionButton}
    </div>
  );
}
